export default __webpack_public_path__ + "static/08-678af149132d24d8ae6bbfc826c9400e.jpg";